/** Basecamp workspace role IDs returned on `/bff/api/me/workspaces`. */
export const BASECAMP_SUPER_ADMIN_ROLE_ID = 1;
export const BASECAMP_ADMIN_ROLE_ID = 2;
export const BASECAMP_USER_ROLE_ID = 3;

/**
 * Super admin (internal): full product access, bypasses workspace SKU checks elsewhere.
 */
export function isBasecampWorkspaceSuperAdminRole(roleId: number): boolean {
  return roleId === BASECAMP_SUPER_ADMIN_ROLE_ID;
}

/**
 * Workspace admin (role 2) or super admin. Used for Account Admin, company details,
 * create-dashboard route, and Reveal edit when combined with SKU checks.
 */
export function isBasecampWorkspaceAdminTier(
  isWorkspaceSuperAdmin: boolean,
  workspaceRoleId: number,
): boolean {
  if (isWorkspaceSuperAdmin)
    return true;
  return workspaceRoleId === BASECAMP_ADMIN_ROLE_ID;
}
